import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobFullDetailsToolsButtonsDownloadAppraisalsAndReceiptsForJob from
    "./tools/buttons/job-full-details-tools-buttons-download-appraisals-and-receipts-for-job.jsx";
import JobFullDetailsToolsButtonsJobSplitter from
    "./tools/buttons/job-full-details-tools-buttons-job-splitter.jsx";
import JobFullDetailsToolsButtonsJobSubcontractor from
    "./tools/buttons/job-full-details-tools-buttons-job-subcontractor.jsx";
import JobFullDetailsToolsButtonsAbortUnabort from
    "./tools/buttons/job-full-details-tools-buttons-abort-unabort.jsx";
import JobFullDetailsToolsButtonsCancelUncancel from
    "./tools/buttons/job-full-details-tools-buttons-cancel-uncancel.jsx";
import JobFullDetailsToolsButtonsRemoveDriverFromJob from
    "./tools/buttons/job-full-details-tools-buttons-remove-driver-from-job.jsx";
import JobFullDetailsToolsButtonsDeleteUndelete from
    "./tools/buttons/job-full-details-tools-buttons-delete-undelete.jsx";
import JobFullDetailsToolsButtonsMoveJobToDelivered from
    "./tools/buttons/job-full-details-tools-buttons-move-job-to-delivered.jsx";
import JobFullDetailsToolsButtonsMarkUnmarkJobAsHasAnIssue from
    "./tools/buttons/job-full-details-tools-buttons-mark-unmark-job-as-has-an-issue.jsx";
import JobFullDetailsToolsButtonsMarkUnmarkJobAsHasAMajorIssue from
    "./tools/buttons/job-full-details-tools-buttons-mark-unmark-job-as-has-a-major-issue.jsx";
import JobFullDetailsToolsButtonsMarkUnmarkJobAsPrechecked from
    "./tools/buttons/job-full-details-tools-buttons-mark-unmark-job-as-prechecked.jsx";
import JobFullDetailsToolsButtonsMarkUnmarkJobAsChecked from
    "./tools/buttons/job-full-details-tools-buttons-mark-unmark-job-as-checked.jsx";
import JobFullDetailsToolsButtonsMarkUnmarkJobAsVehicleOnSite
  from "./tools/buttons/job-full-details-tools-buttons-mark-unmark-job-as-vehicle-on-site";
import JobFullDetailsToolsButtonsMarkUnmarkJobAsNeedsPlanningAsap
  from "./tools/buttons/job-full-details-tools-buttons-mark-unmark-job-as-needs-planning-asap";
import JobFullDetailsToolsButtonsMarkUnmarkJobAsDoesNotRequirePlanningYet
  from "./tools/buttons/job-full-details-tools-buttons-mark-unmark-job-as-does-not-require-planning-yet";
import JobFullDetailsToolsButtonsMarkUnmarkJobAsPOCPODchecked from
  "./tools/buttons/job-full-details-tools-buttons-mark-unmark-job-as-poc-pod-checked.jsx";
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsTools extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      showJobScheduler: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }
  createXJobsFromThisJob(e) {
    let x = $('.number_of_new_jobs_to_create').val();
    let jobId = this.state.data.id;
    window.location.href('/add-new-job/'+jobId+'/x/'+x);
  }
  render() {
    return (
      <div
        className="job-full-details-job-controls-container"
      >
        <div
          className="row"
        >
          <div
            className="col-md-6"
          >
            <JobFullDetailsToolsButtonsDownloadAppraisalsAndReceiptsForJob
              data={this.state.data}
            />
            <br /><br />
            <br /><br />
            <JobFullDetailsToolsButtonsJobSplitter
              data={this.state.data}
            />
            <br /><br />
            <JobFullDetailsToolsButtonsJobSubcontractor
              data={this.state.data}
            />
          </div>
          <div className="col-md-6">
            <JobFullDetailsToolsButtonsAbortUnabort
              data={this.state.data}
            />&nbsp;&nbsp;
            <JobFullDetailsToolsButtonsCancelUncancel
              data={this.state.data}
            />
            <br /><br />
            <JobFullDetailsToolsButtonsRemoveDriverFromJob
              data={this.state.data}
            />
            <br /><br />
            <JobFullDetailsToolsButtonsDeleteUndelete
              data={this.state.data}
            />
            <br /><br />
            <br /><br />
            <JobFullDetailsToolsButtonsMoveJobToDelivered
              data={this.state.data}
            />
          </div>
        </div>
        <div
          className="full-details-main-details-alerts-container"
        >
          {(this.state.isSplitJob !== false) ?
            <div className="alert alert-danger">
              This is a split job</div> : null
          }
          {(this.state.hasSplitParent !== false) ?
            <div className="alert alert-danger">
              This job has been split from:&nbsp;
              <a href={"/jobs/view/"+
              this.state.data.split_parent_id}>
                Job #{this.state.data.split_parent_id}
              </a>
            </div> : null
          }
          {(this.state.hasSplitJobs !== false) ?
            <div className="alert alert-danger">
              This job has been split into:&nbsp;
              <a href={"/jobs/view/"+
              this.state.data.split_child_a_id}>
                Job #{this.state.data.split_child_a_id}
              </a> and&nbsp;
              <a href={"/jobs/view/"+
              this.state.data.split_child_b_id}>
                Job #{this.state.data.split_child_b_id}
              </a>
            </div> : null
          }
        </div>
        <div
          className="job-full-details-job-planning-actions-container"
        >
          <h1>Admin Work</h1>
          <div
            className="job-row-highlighting-container"
          >
            <JobFullDetailsToolsButtonsMarkUnmarkJobAsHasAnIssue
              data={this.state.data}
            />
            <JobFullDetailsToolsButtonsMarkUnmarkJobAsHasAMajorIssue
              data={this.state.data}
            />
            <JobFullDetailsToolsButtonsMarkUnmarkJobAsPOCPODchecked
              data={this.state.data}
            />
            <JobFullDetailsToolsButtonsMarkUnmarkJobAsPrechecked
              data={this.state.data}
            />
            <JobFullDetailsToolsButtonsMarkUnmarkJobAsChecked
              data={this.state.data}
            />
            <JobFullDetailsToolsButtonsMarkUnmarkJobAsVehicleOnSite
              data={this.state.data}
            />
            <JobFullDetailsToolsButtonsMarkUnmarkJobAsNeedsPlanningAsap
              data={this.state.data}
            />
            <JobFullDetailsToolsButtonsMarkUnmarkJobAsDoesNotRequirePlanningYet
              data={this.state.data}
            />
          </div>
          <h2>Create new job</h2>
          Create
          <input
            type="text"
            className="number_of_new_jobs_to_create"
            maxLength="2"
            name="number_of_new_jobs_to_create"
          />
          jobs from this job
          <button
            className="btn btn-lg btn-success"
            onClick={(e) => {this.createXJobsFromThisJob(e)}}
          >
            Go
          </button>
        </div>
      </div>
    );
  }
}